import produce from 'immer';
import {
  APP_CREATE_REQUEST,
  APP_INFO_REQUEST, APP_INFO_UPDATE_REQUEST,
  APP_LIST_REQUEST, APP_PLAYSTORE_SEARCH_REQUEST, APP_REMOVE_REQUEST, APP_RESPONSE_MESSAGE,
  SET_APP_INFO,
  SET_APP_LIST,
  SET_APP_PAGE, SET_REQUEST_STATUS
} from '../../constants/app/gameConstants';

const initialState = {
  appList: [],
  appInfo: {},
  page: 1,
  pageLength: 10,
  totalCount: 0,
  searchString: '',
  requestStatus: {},
  message: '',
  kind: '',
  resultCode: null,
};

/* eslint-disable default-case, no-param-reassign */
const gameReducer = (state = initialState, action = {}) => produce(state, draft => {
  switch (action.type) {
    case APP_LIST_REQUEST:
    case APP_INFO_REQUEST:
    case APP_PLAYSTORE_SEARCH_REQUEST:
    case APP_REMOVE_REQUEST:
    case APP_CREATE_REQUEST:
    case APP_INFO_UPDATE_REQUEST:
      break;
    case SET_APP_LIST:
      draft.appList = action.list;
      break;
    case SET_APP_PAGE:
      draft.page = action.page;
      draft.pageLength = action.pageLength;
      draft.totalCount = action.totalCount;
      draft.searchString = action.searchString;
      break;
    case SET_APP_INFO:
      draft.appInfo = action.info;
      break;
    case SET_REQUEST_STATUS:
      draft.message = action.message;
      draft.kind = action.kind;
      break;
    case APP_RESPONSE_MESSAGE:
      draft.resultCode = action.resultCode;
      break;
    default:
      break;
  }
});

export default gameReducer;
